export const getFamilyCategory = (categories) => {
  if (!Array.isArray(categories) || categories.length === 0) return null;

  const first = categories[0];
  if (first?.isFamily) return first;

  const hierarchy = first?.categoryHierarchy;
  if (!Array.isArray(hierarchy) || hierarchy.length === 0) return null;

  return hierarchy.find((cat) => cat.isFamily) ?? null;
};

export const isProductInFamily = (categories) =>
  getFamilyCategory(categories) != null;
